import { OnInit, Component } from '@angular/core';
import { ProductionPlanningProjectsService } from "../../data/production-planning-projects.service";
import { DeviceDetectorService } from "ngx-device-detector";
import { ConfirmationService } from "primeng/api";
import {Router} from '@angular/router';

@Component({
  selector: 'app-production-planning-calendar',
  templateUrl: './production-planning-calendar.component.html',
  styleUrls: ['./production-planning-calendar.component.scss'],
  providers: [
    ProductionPlanningProjectsService,
    DeviceDetectorService,
    ConfirmationService
  ]
})
export class ProductionPlanningCalendarComponent implements OnInit {

  constructor(
      public router: Router
  ) {

  }

  ngOnInit(): void {
  }

}
